import React, { ComponentPropsWithRef, FC, forwardRef, useMemo } from "react";

import cn from "@/utils/cn";

interface LabelProps extends ComponentPropsWithRef<"label"> {
  required?: boolean;
  reverse?: boolean;
  children: React.ReactNode;
}
const Label = forwardRef<HTMLLabelElement, LabelProps>(({ required, reverse = false, children, ...rest }, ref) => {
  const cssClass = useMemo(() => {
    return cn(rest?.className, "flex text-s font-secondary items-center");
  }, [rest?.className]);
  return (
    <label className={`${cssClass} ${!!reverse ? "text-white" : ""}`} ref={ref} {...rest}>
      {children}
      {required && "*"}
    </label>
  );
});
Label.displayName = "Label";
export default Label;
